import styled from '@emotion/styled';
import { N200, N800 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var Text = styled.h3({
  display: 'inline',
  color: "var(--ds-text, ".concat(N800, ")"),
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var Timestamp = styled.span({
  fontSize: '14px',
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  fontWeight: 400,
  whiteSpace: 'nowrap',
  marginLeft: "var(--ds-space-050, 4px)"
});